export const PACKAGES = 'packages';
export const IMAGES = 'images';
export const CONTENT = 'content';
export const CONTENT_FIELDS = [
  'satisfaction_survey_link',
  'type',
  'booking_type',
  'name',
  'description',
  'additional_description',
  'location',
  'highlights',
  'what_we_like',
  'facilities',
  'tour_flight_details_required',
  'no_index',
  'enable_customer_portal_date_change',
  'booking_guarantee',
  'getting_there',
  'fine_print',
  'transfer_details',
  'flight_destination_port',
  'flights_enabled',
  'locations',
  'holiday_types',
  'offer_inclusions',
  'offer_tile_inclusion_heading',
  'preheader',
  'sale_unit',
  'subject_line',
  'panel_cloudinary_id',
  'videos',
];
